export default __webpack_public_path__ + "static/media/procedure.162b9f3f.jpg";